/* eslint-disable default-case, no-param-reassign */
import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import produce from 'immer';
import { actions, AuthActions } from '.';
import { AuthState } from './types';

const initialState: AuthState = {};

const reducer: Reducer<AuthState, AuthActions> = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case getType(actions.setAuth): {
        draft = action.payload;
        break;
      }
      case getType(actions.removeAuth): {
        draft.accessToken = undefined;
        draft.tokenType = undefined;
        draft.expiresIn = undefined;
        break;
      }
    }

    return draft as AuthState;
  });

export default reducer;
